import { render, staticRenderFns } from "./AstraTopElementWeightTableColumn.vue?vue&type=template&id=22734ca5"
import script from "./AstraTopElementWeightTableColumn.vue?vue&type=script&lang=js"
export * from "./AstraTopElementWeightTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports